import React from 'react'
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageSection from "../../components/layout/PageSection";
import PageTitle from "../../components/layout/PageTitle";
import PageContainer from "../../components/layout/PageContainer";
import RangoEdadForm from "./RangoEdadForm";


const RangoEdadNew = () => {
  const navigate = useNavigate()

  const onCreate = async (rango) => {
    rango.sexo = "a"
    rango.matrizAsignada = 1
    await axios.post(Apis.PROD + '/rango-edad/new',rango)
      .then(res => {
        successToast("Grupo etario creado correctamente")
        navigate('/rango-edad')
      })
      .catch(err => {
        errorToast(err.response.data.message,6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Grupos etarios' onClick={() => navigate('/rango-edad')}/>
        <PageTitle title={'Grupo etario nuevo'}/>
      </PageSection>

      <PageSection>
        <RangoEdadForm value={{}} onSubmit={(rango) => onCreate(rango)}/>
      </PageSection>
    </PageContainer>
  )
}

export default RangoEdadNew;
